import { Box } from '@mui/material';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';
import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';

interface ActionBarProps extends Partial<PickersActionBarProps> {
  onAccept: () => void;
  onCancel: () => void;
  saveDisabled?: boolean;
}

/**
 * Custom action bar component for the DateTimePicker
 */
function ActionBar({ onAccept, onCancel, saveDisabled }: ActionBarProps) {
  const [t] = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '1rem',
        padding: '1rem',
        justifyContent: 'center',
        borderTop: '1px solid #E0E0E0',
      }}
    >
      <Button
        label={t('common.cancel')}
        color="alternative1Button"
        type="button"
        onClick={onCancel}
        sx={{ width: '100%', height: '3rem', fontSize: '1.125rem' }}
      />
      <Button
        label={t('common.save')}
        color="primaryButton"
        type="button"
        onClick={onAccept}
        disabled={saveDisabled}
        sx={{ width: '100%', height: '3rem', fontSize: '1.125rem' }}
      />
    </Box>
  );
}

export default ActionBar;
